import type { Desafio } from '../../types/quiz.types';
import { SoundManager } from '../../utils/SoundManager';

interface Props {
  desafio: Desafio;
  onComplete: (sucesso: boolean) => void;
}

export function DueloAncestraisMinigame({ desafio, onComplete }: Props) {
  return (
    <div className="w-full flex flex-col justify-between gap-2 sm:gap-3 select-none">
      <p className="text-slate-300 text-fluid-body leading-tight text-center sm:text-left font-medium">
        {desafio.instrucao}
      </p>

      <div className="p-3 sm:p-4 bg-amber-950/20 border border-amber-500/40 rounded-xl">
        <p className="text-amber-200 font-medium text-fluid-body leading-relaxed">
          &quot;Você tem Axé acumulado nesta fase. Se acertar a próxima pergunta sem ajudas, o Axé que ela renderia será dobrado. Se errar, você perde o checkpoint atual. Aceita?&quot;
        </p>
      </div>

      <div className="flex gap-2.5 pt-1">
        <button
          type="button"
          onClick={() => {
            SoundManager.playDueloAceito();
            onComplete(true);
          }}
          className="btn-cyber flex-1 py-2.5 sm:py-3 min-h-[clamp(3rem,7dvh,4.25rem)] rounded-xl bg-emerald-600 text-white font-cyber font-bold hover:bg-emerald-500 text-fluid-body shadow-lg shadow-emerald-950/50 uppercase tracking-wider border border-emerald-400"
        >
          Aceitar
        </button>
        <button
          type="button"
          onClick={() => {
            SoundManager.playClick();
            onComplete(false);
          }}
          className="btn-cyber flex-1 py-2.5 sm:py-3 min-h-[clamp(3rem,7dvh,4.25rem)] rounded-xl bg-slate-800 text-slate-300 font-cyber font-bold hover:bg-slate-700 text-fluid-body border border-slate-600 uppercase tracking-wider"
        >
          Recusar
        </button>
      </div>
    </div>
  );
}
